import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import LatestGrid from './components/LatestGrid';
import CategoriesSection from './components/CategoriesSection';
import CTASection from './components/CTASection';
import { useEffect } from 'react';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '17黑料网',
  url: 'http://yiyaxiang.cn/',
  description: '17黑料网官网入口页面，覆盖17黑料吃瓜、17吃瓜黑料等核心内容，每日追踪网红塌房、黑料视频、争议事件，提供最新吃瓜资源在线观看。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://yiyaxiang.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '17黑料网',
  url: 'http://yiyaxiang.cn/',
  description: '17黑料网是领先的网红黑料追踪与吃瓜资讯平台，每日更新最新网红塌房事件、黑料视频、争议热点。',
  foundingDate: '2020',
};

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '17黑料网官网 - 17黑料吃瓜与17吃瓜黑料 | 网红黑料视频每日追踪',
  description: '17黑料网官网📰入口页面，覆盖17黑料吃瓜、🎥17吃瓜黑料等核心内容，每日追踪网红塌房、黑料视频、争议事件，提供最新吃瓜资源在线观看。',
  url: 'http://yiyaxiang.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '17黑料网',
  },
};

export default function Home() {
  useEffect(() => {
    document.title = '17黑料网官网 - 17黑料吃瓜与17吃瓜黑料 | 网红黑料视频每日追踪';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '17黑料网官网📰入口页面，覆盖17黑料吃瓜、🎥17吃瓜黑料等核心内容，每日追踪网红塌房、黑料视频、争议事件，提供最新吃瓜资源在线观看。17黑料网,17黑料吃瓜,17吃瓜黑料');
    }
  }, []);

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <FeatureGrid />
      <CategoriesSection />
      <LatestGrid />
      <CTASection />
      <Footer />
    </main>
  );
}